<template>
    <layout-default-app-bar filterable
    :filters="filters">
    {{ isPromo ? 'Promoções' : 'Produtos' }}
  </layout-default-app-bar>
</template>

<script>
import { CADASTRO_PEDIDO_PRODUTO_QUERIES } from '@/constants/QUERY_FILTERS';

import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

    data() {
    return {
      filters: [
        CADASTRO_PEDIDO_PRODUTO_QUERIES.createdFrom,
        CADASTRO_PEDIDO_PRODUTO_QUERIES.createdBefore,
      ],
    };
  },

  components: {
    LayoutDefaultAppBar,
  },
  computed: {
    isPromo() {
      return this.$route && this.$route.query && this.$route.query.promo === '1';
    }
  }
};

</script>
